import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const AuthContent = styled(Box)(() => ({
    display: "flex",
    flexDirection: "column",
    minHeight: "170px",
}));
